
import path from 'path'
export function isExternal (path:string):boolean {
  return /^https?:/.test(path)
}

export function resolvePath (basePath: string, routePath: string):string {
  if (isExternal(routePath)) {
    return routePath
  }
  if (isExternal(basePath)) {
    return basePath
  }
  return basePath ? path.resolve(basePath, routePath) : routePath
}
